import { defineComponent } from "vue";
import { useLocale } from "../locales/i18n.js";

const ToolCards = [
    {
        icon       : "auto_awesome",
        titleKey   : "tools.list.community_engagement.title",
        descKey    : "tools.list.community_engagement.description",
        to         : "/tools/community-engagement",
    },
    {
        icon       : "hub",
        titleKey   : "tools.list.graph.title",
        descKey    : "tools.list.graph.description",
        to         : "/graph",
    },
    {
        icon       : "admin_panel_settings",
        titleKey   : "tools.list.permissions_simulator.title",
        descKey    : "tools.list.permissions_simulator.description",
        to         : "/tools/permissions-simulator",
    },
    {
        icon       : "manage_accounts",
        titleKey   : "tools.list.bulk_role_permissions.title",
        descKey    : "tools.list.bulk_role_permissions.description",
        to         : "/tools/bulk-role-permissions",
    },
] as const;

export default defineComponent({
    setup() {
        const { i18n } = useLocale();

        return () => (
            <div class="tools-page">
                <div class="tools-hero">
                    <span class="tools-eyebrow">{i18n("tools.page.eyebrow")}</span>
                    <h1>{i18n("tools.page.title")}</h1>
                    <p>{i18n("tools.page.description")}</p>
                </div>

                <div class="tools-grid">
                    {ToolCards.map((tool) => (
                        <router-link class="tools-card" to={tool.to}>
                            <i class="material-symbols-outlined">{tool.icon}</i>
                            <div>
                                <strong>{i18n(tool.titleKey)}</strong>
                                <span>{i18n(tool.descKey)}</span>
                            </div>
                            <em class="material-symbols-outlined">arrow_forward</em>
                        </router-link>
                    ))}
                </div>
            </div>
        );
    },
});
